import React from 'react';
import './tailwind.css';
import { createRoot } from 'react-dom/client';
import AdminDashboard from './AdminDashboard';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<AdminDashboard />);
